import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import seoMetaData from "../../Include/Seo/seoMetaData";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import men from "../../../assets/images/men.svg";
import Navbar from "../../Include/Navbar/Navbar";
import Footer from "../../Include/Footer/Footer";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";
import ContactFormSection from "../../../component/contact/ContactFormSection";
import Contact from "../Home/Contact";
import { FaX } from "react-icons/fa6";

export default function ContactSection() {
  const { title, description } = seoMetaData.contact;
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href="https://www.cloudkode.com/contact-us" />
      </Helmet>
      <Navbar />
      {/* breadcum */}
      <Container className="py-5">
        <h2
          className="text-center fw-bold mb-2"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          CONTACT US
        </h2>
        <p
          className="text-center text-muted mb-5"
          data-aos="fade-up"
          data-aos-duration="2000"
          data-aos-delay="100"
        >
          We align leaders around a shared purpose and strategic story that
          catalyzes their business and brand to take action.
        </p>
      </Container>
      {/* form */}
      <Contact sectionId="contact-page-contact" />
      {/* social */}
      <section className="overflow-hidden">
        <Container className="py-5">
          <Row>
            <Col lg={12} data-aos="fade-up" data-aos-duration="2000">
              <h2 className="text-center">Our Cloud Offices</h2>
              <hr />
            </Col>
            <Col lg="4">
              <div
                className="card-sorath-contact text-center"
                data-aos="fade-up"
                data-aos-duration="2000"
                data-aos-delay="100"
              >
                <FaMapMarkerAlt className="me-2 address-sorath" />
                <h4>Head Office</h4>
                <p>Mau, Uttar Pradesh, India - 275101</p>
              </div>
            </Col>

            <Col lg="4">
              <div
                className="card-sorath-contact text-center"
                data-aos="fade-up"
                data-aos-duration="2000"
                data-aos-delay="100"
              >
                <FaMapMarkerAlt className="me-2 address-sorath" />
                <h4>Remote Office</h4>
                <p>Nalanda, Bihar, India - 803116</p>
              </div>
            </Col>

            <Col lg="4">
              <div
                className="card-sorath-contact text-center"
                data-aos="fade-up"
                data-aos-duration="2000"
                data-aos-delay="100"
              >
                <FaMapMarkerAlt className="me-2 address-sorath" />
                <h4>Remote Office</h4>
                <p>102, Crystal Avenue, Surat, Gujarat - 395006</p>
              </div>
            </Col>
          </Row>
        </Container>

        <Container className="py-5">
          <Row>
            <Col lg={12} data-aos="fade-up" data-aos-duration="2000">
              <h2 className="text-center">Connect With Us</h2>
              <hr />
            </Col>
            <Col lg="4">
              <div
                className="card-sorath-contact text-center"
                data-aos="fade-up"
                data-aos-duration="2000"
                data-aos-delay="100"
              >
                <FaPhoneAlt className="me-2 address-sorath" />
                <h4>Call Us</h4>
                <a href="tel:+919650792424">+91 965 079 2424</a>
              </div>
            </Col>

            <Col lg="4">
              <div
                className="card-sorath-contact text-center"
                data-aos="fade-up"
                data-aos-duration="2000"
                data-aos-delay="100"
              >
                <FaEnvelope className="me-2 address-sorath" />
                <h4>Email Us</h4>
                <a href="mailto:info@cloudkodeform.com">
                  info@cloudkodeform.com
                </a>
              </div>
            </Col>

            <Col lg="4">
              <div
                className="card-sorath-contact text-center"
                data-aos="fade-up"
                data-aos-duration="2000"
                data-aos-delay="100"
              >
                <div>
                  <a
                    href="https://www.facebook.com/profile.php?id=61566566795061"
                    target="_blank"
                  >
                    <FaFacebookF className="me-2 address-sorath" />
                  </a>
                  <a href="https://x.com/cloudkodeform" target="_blank">
                    <FaTwitter className="me-2 address-sorath" />
                  </a>
                  <a
                    href="https://www.instagram.com/cloudkodeform/?hl=en"
                    target="_blank"
                  >
                    <FaInstagram className="me-2 address-sorath" />
                  </a>
                  <a
                    href="https://www.linkedin.com/in/cloudkodeform-technologies-13a7282b8"
                    target="_blank"
                  >
                    <FaLinkedinIn className="me-2 address-sorath" />
                  </a>
                </div>
                <h4>Social Connect</h4>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Footer />
    </>
  );
}
